var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-7',[_c('div',{staticClass:"line_title",on:{"click":function($event){return _vm.routerFtqTop()}}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('dv-decoration-10',{staticStyle:{"width":"100%","height":"5px"}}),_vm._v(" "),_c('dv-scroll-board',{attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dab0f24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/oee/component/oee-productline-ftq.vue
// module id = null
// module chunks = 